import { render, staticRenderFns } from "./reply-rating.vue?vue&type=template&id=a4e7db2e&scoped=true"
import script from "./reply-rating.vue?vue&type=script&lang=js"
export * from "./reply-rating.vue?vue&type=script&lang=js"
import style0 from "./reply-rating.vue?vue&type=style&index=0&id=a4e7db2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e7db2e",
  null
  
)

export default component.exports